import React from 'react';

export const PVLogo = ({ width = '18', height = '18', fill = 'var(--icon-color-base)' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.75 6.75C6.75 5.50736 7.75733 4.5 9.00001 4.5C10.2426 4.5 11.25 5.50736 11.25 6.75"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M11.4802 9H6.51973C5.5315 9 5.03737 9 4.6547 9.25792C4.27202 9.51577 4.08851 9.97245 3.72148 10.8858L3.11872 12.3858C2.36968 14.2499 1.99516 15.1819 2.44341 15.841C2.89167 16.5 3.9001 16.5 5.91697 16.5H12.083C14.0999 16.5 15.1083 16.5 15.5566 15.841C16.0048 15.1819 15.6303 14.2499 14.8813 12.3858L14.2785 10.8858C13.9115 9.97245 13.728 9.51577 13.3453 9.25792C12.9626 9 12.4685 9 11.4802 9Z"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M9 9V16.5" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15 12.75H3" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9 2.25V1.5" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.5 6.75H14.25" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3.75 6.75H4.5" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M12.1836 3.56939L12.7139 3.03906"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.28906 3.03906L5.81939 3.56939"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
